import { useState } from "react";
import { navItems } from "@/mocks/guides";

export default function SiteNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur-md">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <a
            href="#top"
            className="flex items-center gap-2 text-foreground-950 cursor-pointer"
          >
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-film-line text-lg"></i>
            </span>
            <span className="font-heading text-lg font-bold tracking-wide">
              潘金莲电影
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1" aria-label="页面导航">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className="px-3 py-2 text-sm text-foreground-700 rounded-md hover:text-primary-700 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href="#recommend"
              className="inline-flex items-center gap-2 px-4 py-2 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-bookmark-line"></i>
              查看推荐
            </a>
          </div>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开导航菜单"
            aria-expanded={open}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200/70 bg-background-50">
          <nav className="px-4 py-3 grid grid-cols-2 gap-2" aria-label="移动端导航">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="px-3 py-3 text-sm text-foreground-800 rounded-md bg-background-100 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}